module.exports = __webpack_public_path__ + "static/media/check.ce20ce8e.svg";